import { createSIWEConfig, formatMessage, } from '@reown/appkit-siwe';
import { API } from '../actions/URL';
import axios from '../actions/myaxios';
import { store } from '../store';
import { appTemp } from '../actions/actionTypes';
import { globalData } from '../actions/globalVariables';
const siweConfig = createSIWEConfig({
    getNonce: async () => {
        // The getNonce method functions as a safeguard
        // against spoofing, akin to a CSRF token.
        // It should be called before any message is signed.
        const res = await axios.get(`${API}/api/generate-nonce/`);
        return res.data;
    },
    verifyMessage: async ({ message, signature }) => {
        try {
            // This function ensures the message is valid,
            // has not been tampered with, and has been appropriately
            // signed by the wallet address.
            const res = await axios.post(`${API}/api/verify-siwe/`, { message, signature });
            globalData.walletVerifyResponse = res;
            return res.data.correct;
        }
        catch (error) {
            return false;
        }
    },
    getSession: async () => {
        // The backend session should store the associated address and chainId
        // and return it via the `getSession` method.;
        const response = await axios.get(`${API}/api/get-session/`);
        const session = response.data;
        if (!session.exists)
            return null;
        return session;
    },
    signOut: async () => {
        try {
            // The users session must be destroyed when calling `signOut`.
            await axios.get(`${API}/api/flush-session/`);
            return true;
        }
        catch {
            return false;
        }
    },
    createMessage: ({ address, ...args }) => {
        // Method for generating an EIP-4361-compatible message.
        return formatMessage(args, address);
    },
    getMessageParams: () => {
        // Parameters to create the SIWE message internally.
        // More info in https://github.com/ChainAgnostic/CAIPs/blob/main/CAIPs/caip-222.method
        const siweMessage = {
            domain: 'sticknet.org',
            uri: 'https://sticknet.org',
            chains: [1],
            statement: 'Please sign with your account',
            iat: new Date().toISOString(),
        };
        return Promise.resolve(siweMessage);
    },
    onSignIn: (session) => {
        store.dispatch({ type: appTemp.DISPATCH_APPTEMP_PROPERTY, payload: { walletVerified: session?.address } });
    },
});
export default siweConfig;
